import { useContext } from 'react';
import CallContext from './context';

const useSbCalls = () => useContext(CallContext);

export default useSbCalls;
